module.exports = __webpack_public_path__ + "static/media/money-red.f620dcb0.svg";